<div class="gray-bg-rounded">
  <div class="today-task">
    <p-accordion value="0">
      <p-accordion-panel value="0">
        <p-accordion-header>
          <div class="d-flex justify-content-between topboder">
            <span class="d-flex justify-content-between gap-2 align-items-top">
              <span> <i class="pi pi-link"></i></span>
              <h2 class="mb-0">
                Linked Projects
                <jni-spinner *ngIf="showSmallLoader"></jni-spinner>
              </h2>
            </span>
          </div>
        </p-accordion-header>
        <p-accordion-content>
          <div class="today-list-bar p-0 pr-1">
            <div class="box-height">
              <div
                *ngIf="
                  !showSmallLoader && linkedProjects.length > 0;
                  else noList
                ">
                <div
                  *ngFor="let item of linkedProjects"
                  class="d-flex gap-1 mt-1 mb-3 align-items-center">
                  <div *ngIf="item.salesOrderId">
                    <h3 class="m-0">
                      {{ item.jobName }} -
                      <a
                        (click)="
                          openWorkflowSummaryModal(
                            item.salesOrderId,
                            item?.projectPaddedId ?? 0
                          )
                        "
                        href="javascript:;"
                        class="text-decoration-none"
                        >{{ item.projectPaddedId }}</a
                      >
                    </h3>
                    <p class="mb-0">{{ item.client }}</p>
                  </div>
                </div>
              </div>

              <ng-template #noList>
                <div class="col-lg-12 today-list-bar gray-bg">
                  <div
                    class="lds-ring inline me-auto ms-2"
                    *ngIf="showSmallLoader">
                    <div></div>
                    <div></div>
                    <div></div>
                  </div>
                  <p *ngIf="!showSmallLoader">No linked projects available.</p>
                </div>
              </ng-template>
            </div>
          </div>
        </p-accordion-content>
      </p-accordion-panel>
    </p-accordion>
  </div>
</div>
